import { InlineText1 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';
import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';
import * as styles from './AuctionMobile.css';
import { BetInputContainer } from '../BetInput';
import { BetPositionContainer } from '../BetPosition';
import { BetLeadersTitleContainer } from '../BetLeadersTitle';
import { BetLeadersContainer } from '../BetLeaders';
import { AutobrokerContainer } from '../Autobroker';

interface IAuctionMobileProps {
  isOpen: boolean;
  isAcceptDisabled: boolean;
  isAutobrokerEnabled: boolean;
  onClose(): void;
  onClear(): void;
  onAccept(): void;
}

export const AuctionMobile = ({
  isOpen,
  isAcceptDisabled,
  isAutobrokerEnabled,
  onClose,
  onClear,
  onAccept,
}: IAuctionMobileProps) => {
  const footer = (
    <div className={styles['footer']}>
      <div className={styles['button']}>
        <Button type="button" fullWidth theme="fill_secondary" onClick={onClear}>
          Сбросить
        </Button>
      </div>

      <div className={styles['button']}>
        <Button type="button" fullWidth disabled={isAcceptDisabled} onClick={onAccept}>
          Применить
        </Button>
      </div>
    </div>
  );

  return (
    <ModalWindow
      open={isOpen}
      onClose={onClose}
      title="Опередить конкурентов"
      footer={isAutobrokerEnabled ? null : footer}
    >
      <div className={styles['content']}>
        {isAutobrokerEnabled && <AutobrokerContainer />}

        {!isAutobrokerEnabled && (
          <>
            <InlineText1 color="gray60_100">
              Всё работает по&nbsp;принципу аукциона. Вы делаете ставку на&nbsp;позицию, и&nbsp;эта&nbsp;позиция
              фиксируется до&nbsp;тех&nbsp;пор, пока&nbsp;кто-то не&nbsp;перебьёт вашу ставку.
            </InlineText1>

            <div className={styles['bet']}>
              <BetInputContainer />
              <BetPositionContainer />
            </div>

            <div className={styles['leaders']}>
              <BetLeadersTitleContainer />
              <BetLeadersContainer />
            </div>
          </>
        )}
      </div>
    </ModalWindow>
  );
};
